import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/images/menuIcons/Logos.svg'
import _imports_1 from '@/assets/spinners/eclipse.svg'


const _hoisted_1 = {
  style: {"position":"relative"},
  class: "logo-container"
}
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "Logo",
  class: "logo img-primary",
  style: {"position":"absolute","margin-top":"-0.2rem","margin-left":"-0.2rem"}
}


export default /*@__PURE__*/_defineComponent({
  __name: 'loadingSpinner',
  props: {
  logo: {
    type: Boolean,
    default: true,
  },
  style: {
    type: String,
    default: "w-6",
  }
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.logo)
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("img", {
      src: _imports_1,
      class: _normalizeClass([props.style, props.logo ? 'img-primary' : ''])
    }, null, 2)
  ]))
}
}

})